import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames';

import { PageWrapper, Loader, Alert, ErrorText } from '../../components';
import Actions, { thunks } from '../../redux/modules/delivery';
import SlotModal from './components/slotModal';
import { DELIVERY_CHARGE } from '../../constants';

class Delivery extends React.Component {
    state = {
        slotToUpdate: null,
        slotToDelete: null,
        isFreeDeliveryAlert:false
    }

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(thunks.getSlots());
        dispatch(thunks.getPreference());
        dispatch(thunks.getTonnageCharge())
    }
    
    onEditSlot = slotToUpdate => {
        const { updateProperty } = this.props;
        this.setState({ slotToUpdate }, () => {
            updateProperty('showSlotModal', true);
        })
    }

    onChangePreference = e => {
        const { updateProperty, preferences,dispatch } = this.props;
        const { name, value, checked } =  e.target
        
        if(checked)
        this.setState({isFreeDeliveryAlert:true})
        else{
            const newPref = preferences.map(p => {
                if (p.preferenceName === name) p.preference = name !== 'is_free_delivery' ? value : (checked ? '1' : '0')
                p.error = '';
                return p;
            })
            updateProperty('preferences', newPref.filter((preference) => preference.preferenceName == 'is_free_delivery'))
            this.setState({isFreeDeliveryAlert:false})
            dispatch(thunks.updateDeliveryPreference())
        }
        
    }
    handleCheckFreeDelivery = () =>{
        const { updateProperty, preferences,dispatch } = this.props;
        const newPref = preferences.map(p => {
            p.preference = '1'
            p.error = '';
            return p;
        })
        this.setState({isFreeDeliveryAlert:false})
        updateProperty('preferences', newPref.filter((preference) => preference.preferenceName == 'is_free_delivery'))
        dispatch(thunks.updateDeliveryPreference())
    }
    onChangeTonnage = e => {
        const { updateProperty, tonnage_charges } = this.props;
        const { name, value, checked } =  e.target
        const newTonnage = tonnage_charges.map(p => {
          
            if (p.minimumTonnage == name){
               
                p.chargePerKilometer = value
            } 
            p.error = '';
            
            return p;
        })
        updateProperty('tonnage_charges', newTonnage)
    }
    onSave = () => {
        const { dispatch, preferences, updateProperty,tonnage_charges } = this.props;
        let hasError = false;
        const newPref = preferences.map(p => {
            // if (p.preferenceName !== 'is_free_delivery') {
            //     if (!p.preference) {
            //         p.error = 'Required';
            //         hasError = true;
            //     } else {
            //         const value = parseInt(p.preference);
            //         if (value <= 0 || value > 100) {
            //             p.error = 'Min. 1 Max. 100';
            //             hasError = true;
            //         }
            //     }
            // }

            return p;
        })
        const newTonnage = tonnage_charges.map(p => {
          
            // if (p.minimumTonnage == name){
            //     console.log("ddddddddddddddddddddddddddddddd",p)
            //     p.chargePerKilometer = value
            // } 
            // p.error = '';
            
            return p;
        })
        if (!hasError) {
            // dispatch(thunks.updateDeliveryPreference())
            dispatch(thunks.updateTonnageCharge())
            
        } else {
            // updateProperty('preferences', newPref)
            updateProperty('tonnage_charges', newTonnage)
        }
    }

    onAddSlot = () => {
        const { updateProperty } = this.props;
        updateProperty('showSlotModal', true);
        this.setState({slotToUpdate:''})
    }

    onHideSlotModal = () => {
        const {  updateProperty } = this.props;
        updateProperty('showSlotModal', false);
    }

    addSlot = body => {
        const { dispatch } = this.props;
        dispatch(thunks.addSlot(body));
    }

    updateSlot = body => {
        const { dispatch } = this.props;
        const { slotToUpdate } = this.state;
        dispatch(thunks.updateSlot(slotToUpdate.id, body));
    }

    handleDeleteSlot = () => {
        const { slotToDelete } = this.state;
        const { dispatch } = this.props;
        dispatch(thunks.deleteSlot(slotToDelete.id));
        this.setState({ slotToDelete: null });
    }
    onDeleteSlot = (slot) => {
        // const { slotToDelete } = this.state;
        this.setState({slotToDelete:slot})
    }
    render() {
        const { 
            list,
            loading,
            error,
            updateProperty,
            loadingPreference,
            loadingTonnage,
            showSlotModal,
            preferences,
            tonnage_charges
        } = this.props;
       
        const { slotToUpdate, slotToDelete,isFreeDeliveryAlert } = this.state;
        const Tonnage_Charges = [
        {
            displayName: "0 to 500",
            preference: "5",
            preferenceName: "0_to_500",
        },
        {
            displayName: "501 to 1000",
            preference: "5",
            preferenceName: "501_to_1000",
        },
        {
            displayName: "1001 to 2000",
            preference: "5",
            preferenceName: "1001_to_2000",
        },
        {
            displayName: "2001 to 3000",
            preference: "5",
            preferenceName: "2001_to_3000",
        },
        {
            displayName: "3001 to 5000",
            preference: "5",
            preferenceName: "3001_to_5000",
        },
        {
            displayName: "5001 to 7000",
            preference: "5",
            preferenceName: "5001_to_7000",
        },
        {
            displayName: "7001 to 10000",
            preference: "5",
            preferenceName: "7001_to_10000",
        },
        {
            displayName: "10001 to 15000",
            preference: "5",
            preferenceName: "10001_to_15000",
        },

    ]
        return (
            <PageWrapper title="Delivery List">
                <Loader show={loading}/>
                <Alert
                    show={!!error}
                    onHide={() => updateProperty('error', '')}
                    title="Delivery"
                    message={error}
                />
                <div className="animated fadeIn">
                    <div className="row mt-3">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row mb-2">
                                        <div className="col-md-12">
                                            <h4>Organisation Preferences</h4>
                                        </div>
                                        {preferences.map(p => (
                                            <div key={p.preferenceName} className="col-md-6">
                                                <div className="form-group">
                                                    {p.preferenceName === 'is_free_delivery' ? (
                                                        <>
                                                            <input
                                                                name={p.preferenceName}
                                                                type="checkbox"
                                                                checked={!!parseInt(p.preference)}
                                                                onChange={this.onChangePreference}
                                                                disabled={loadingPreference}
                                                            />
                                                            <label className="ml-2">{p.displayName}</label>
                                                        </>
                                                    ): null
                                                    // (
                                                    //     <>
                                                    //         <label className={p.error ? 'text-danger' : ''}>{p.displayName}</label>
                                                    //         <input
                                                    //             name={p.preferenceName}
                                                    //             type="number"
                                                    //             value={p.preference}
                                                    //             onChange={this.onChangePreference}
                                                    //             disabled={loadingPreference}
                                                    //             className={classNames('form-control', { 'is-invalid': p.error })}
                                                    //             max="100"
                                                    //             min="0"
                                                    //         />
                                                    //         <ErrorText error={p.error}/>
                                                    //     </>
                                                    // )
                                                    }
                                                </div>
                                            </div>
                                        ))}
                                          </div>
                                          <div className="row">
                                          {tonnage_charges.map((charge)=>(
                                                 
                                                 <div key={charge.minimumTonnage} className="col-md-3 mb-2">
                                                
                                                 <label className={charge.error ? 'text-danger' : ''}>{charge.minimumTonnage} to {charge.maximumTonnage}</label>
                                                 <input
                                                    name={charge.minimumTonnage}
                                                    type="number"
                                                    value={charge.chargePerKilometer}
                                                    onChange={this.onChangeTonnage}
                                                    disabled={loadingTonnage}
                                                    className={classNames('form-control', { 'is-invalid': charge.error })}
                                                    max="100"
                                                    min="0"
                                                />
                                                <ErrorText error={charge.error}/>
                                            </div>
                                             )
                                         )}
                                          </div>
                                       <div className="row"><div className="col-md-12 d-flex justify-content-end mt-2">
                                            <button className="btn btn-primary" onClick={this.onSave}>Save</button>
                                        </div></div>
                                        <div className="row"><div className="col-md-12 d-flex mt-3 mb-3">
                                            <h4 className="flex-1">Delivery Slots</h4>
                                            <button className="btn btn-primary" onClick={this.onAddSlot}>Add Slot</button>
                                        </div></div>
                                        
                                  
                                    <div className="table-responsive">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th className="text-center">#</th>
                                                    <th className="text-center">Slot Number</th>
                                                    <th className="text-center">Max. Kilometers</th>
                                                    <th className="text-center">Min. Amount</th>
                                                    <th className="text-center">Amount</th>
                                                    <th className="text-center">Percentage</th>
                                                    {/* <th>Reduction Per Ton</th>
                                                    <th>Increment Reduction By</th>
                                                    <th>Charge By</th> */}
                                                    <th/>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                    {
                                                        list.length ? (
                                                            list.map(slot => (
                                                                <tr key={slot.id}>
                                                                    <td className="text-center">{slot.id}</td>
                                                                    <td className="text-center">{slot.slotNumber}</td>
                                                                    <td className="text-center">{slot.maximumKilometers}</td>
                                                                    <td className="text-center">{slot.minimumAmount}</td>
                                                                    <td className="text-center">{slot.nonTileProducts.amountToCharge}</td>
                                                                    <td className="text-center">{slot.nonTileProducts.percentageToCharge}</td>
                                                                    {/* <td className="text-center">{slot.reductionPerTon}</td> */}
                                                                    {/* <td className="text-center">{slot.incrementReductionBy}</td> */}
                                                                    {/* <td>{DELIVERY_CHARGE.find(charge => charge.value === slot.nonTileProducts.chargeBy).name}</td> */}
                                                                    <td>
                                                                    <button title="Delete Slot" className="btn btn-xs btn-danger mr-2" onClick={() => this.onDeleteSlot(slot)}>
                                                                            <i className="fa fa-trash"/>
                                                                        </button>
                                                                        <button title="View Slot" className="btn btn-xs btn-info" onClick={() => this.onEditSlot(slot)}>
                                                                            <i className="fa fa-edit"/>
                                                                        </button>
                                                                    </td>
                                                                </tr>
                                                            ))
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="5" className="text-center">No Records Found</td>
                                                            </tr>
                                                        )
                                                    }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
               {showSlotModal&& <SlotModal
                    show={showSlotModal}
                    onHide={this.onHideSlotModal}
                    addSlot={this.addSlot}
                    updateSlot={this.updateSlot}
                    data={slotToUpdate}
                />
               }
                <Alert
                    show={!!slotToDelete}
                    onHide={() => this.setState({ slotToDelete: null })}
                    title="Delete Slot"
                    message={`Are you sure you want to delete Slot ID: ${(slotToDelete || {}).id}?`}
                    onSubmit={this.handleDeleteSlot}
                />
                 <Alert
                    show={isFreeDeliveryAlert}
                    onHide={() => this.setState({ isFreeDeliveryAlert: false })}
                    title="Free delivery"
                    message={`Are you sure you want to make this delivery free?`}
                    onSubmit={this.handleCheckFreeDelivery}
                />
            </PageWrapper>
        )
    }
}

const mapStateToProps = ({
    delivery: {
        loading,
        error,
        list,
        loadingPreference,
        preferences,
        tonnage_charges,
        showSlotModal,
    },
}) => ({
    loading,
    error,
    list,
    loadingPreference,
    preferences,
    tonnage_charges,
    showSlotModal,
});

const mapDispatchToProps = dispatch => ({
    dispatch,
    updateProperty: bindActionCreators(Actions, dispatch).updateProperty,
    reset: bindActionCreators(Actions, dispatch).reset,
});

export default connect(mapStateToProps, mapDispatchToProps)(Delivery)